module.exports = __webpack_public_path__ + "static/Ket2-73399a3b55c650d571e07637e688d8b7.jpg";